import { Divider } from '@packages/shared/src/ui/Divider/Divider';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const MultiStepFormSkeleton = () => (
  <div className="w-dvw">
    <div className="flex flex-row gap-2 p-2">
      <Skeleton className="h-[88px] w-[65px]" />
      <div className="w-full">
        <Skeleton className="mb-2 h-4 w-full" />
        <Skeleton className="mb-1 h-2 w-1/3" />
        <Skeleton className="h-1 w-1/4" />
      </div>
    </div>
    <Divider />
    <div className="flex flex-col gap-2 p-2">
      <Skeleton className="h-[88px] w-1/3 self-center" />
      <div>
        <Skeleton className="mb-1 h-1 w-1/4" />
        <Skeleton className="h-4 w-full" />
      </div>
      <div>
        <Skeleton className="mb-1 h-1 w-1/4" />
        <Skeleton className="h-[88px] w-full" />
      </div>
      <div>
        <Skeleton className="mb-1 h-1 w-1/4" />
        <Skeleton className="h-4 w-full" />
      </div>
      <Skeleton className="h-4 w-full" />
      <div>
        <Skeleton className="mb-1 h-1 w-1/4" />
        <Skeleton className="h-4 w-full" />
      </div>
      <div>
        <Skeleton className="mb-1 h-1 w-1/4" />
        <Skeleton className="h-4 w-full" />
      </div>
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-4 w-1/3 self-end" />
    </div>
  </div>
);
